import request from "@/utils/request";

export default function remove(id) {
    return request({
        url: `/storeType/admin/remove/`+id,
        method: 'get',
    })
}
